import objectPath from 'object-path'
import { loadApiToFormData } from '../../../action/Design'
import { createJsonTable } from '../action/JsonTable'
import { postData, putData } from '../Action'

export const createTableDataHelper = ({
  updateData,
  isFavoriteModal,
  jsonData,
  isChart,
  chartData,
  isLoadJSON,
  isLoadSYNC,
  syncKey,
  uischema,
  formComponentName,
  isDynamic,
  dynamicData,
  formData,
}) => {
  const setTableData = (tableData) => {
    updateData(tableData)
  }

  const getJsonTable = () => {
    if (isFavoriteModal) {
      return jsonData
    }
    if (isChart) {
      return chartData
    }
    if (isLoadJSON) {
      let tableKey = isLoadSYNC ? syncKey : uischema.key
      let tableName = uischema.name
      tableKey = formComponentName
        ? `${formComponentName}.${tableKey}`
        : tableKey
      tableName = formComponentName
        ? `${formComponentName}.${tableName}`
        : tableName
      if (isDynamic) {
        return objectPath.get(dynamicData, tableName) || []
      }
      let jsonTable =
        objectPath.get(formData, tableName) ||
        objectPath.get(formData, tableKey) ||
        objectPath.get(formData, uischema.key) ||
        objectPath.get(formData, uischema.name)
      return jsonTable
    }
    return (
      objectPath.get(formData, uischema.key) ||
      objectPath.get(formData, uischema.name) ||
      []
    )
  }

  return {
    setTableData,
    getJsonTable,
  }
}

export const createTableRefreshHelper = ({
  receivePathParams,
  receiveQueryParams,
  jsonForm,
  formData,
  designerData,
  datasourceValue,
  setFormData,
  propAction,
  uischema,
  tableRefresh,
  isLoadJSON,
  isLoadSYNC,
  jsonTable,
  syncTable,
  syncSelectedRow,
  setLoading,
  setTotalCount,
  setTableRefresh,
  setDataRowClicked,
  setFieldFormData,
  isUiChanged,
  setIsUiChanged,
}) => {
  const refreshTableData = async (uischema) => {
    let urlParams = { ...receivePathParams, ...receiveQueryParams }
    formData = await loadApiToFormData(jsonForm, formData, {
      urlParams,
      designerData,
      datasourceValue,
    })
    setFormData(formData)
    let tableData = objectPath.get(formData, uischema.key)
    createJsonTable(tableData, propAction)
  }

  const rerenderTable = (sourceData) => {
    if (isLoadJSON) {
      createJsonTable(sourceData || jsonTable, propAction)
      syncSelectedRow()
    } else if (isLoadSYNC) {
      createJsonTable(sourceData || syncTable, propAction)
      syncSelectedRow()
    }
  }

  const handleTableRefresh = () => {
    if (tableRefresh.length > 0) {
      setLoading(true)
      let newTableData =
        objectPath.get(jsonForm.formData, uischema.key) ||
        objectPath.get(jsonForm.formData, uischema.name) ||
        []
      tableRefresh.forEach(async (refresh) => {
        if (refresh.isFavorite) {
          let { data = [] } = refresh
          let firstData = objectPath.get(data, 0) || {}
          let tableColumn = []
          Object.keys(firstData).forEach((key) => {
            if (key === 'tableData') return
            let column = {
              title: key,
              field: key,
            }
            tableColumn.push(column)
          })
          newTableData = [...newTableData, ...data]
        } else if (refresh.isButton) {
          let tableData = refresh.data
          if (setTotalCount && refresh.totalCount !== undefined) {
            setTotalCount(refresh.totalCount)
          }
          if (tableData.length > 0) {
            objectPath.set(formData, uischema.key, tableData)
            objectPath.set(formData, uischema.name, tableData)
          } else {
            let urlParams = { ...receivePathParams, ...receiveQueryParams }
            formData = await loadApiToFormData(jsonForm, formData, {
              urlParams,
              designerData,
              datasourceValue,
            })
            setFormData(formData)
          }
        }
      })
      setTimeout(() => {
        let tableData = objectPath.get(formData, uischema.key)
        if (tableData) {
          rerenderTable(tableData)
        }
        setLoading(false)
        setTableRefresh([])
        setDataRowClicked({})
        setFieldFormData(`@rowSelected.${uischema.key}`, {})
        objectPath.set(isUiChanged, ['tableSelection', uischema.key], [])
        setIsUiChanged(isUiChanged)
      }, 500)
    }
  }

  return {
    refreshTableData,
    rerenderTable,
    handleTableRefresh,
  }
}

export const createTableChangedHelper = ({
  tableChanged,
  uischema,
  uiChanged,
  setIsUiChanged,
  designContext,
  renderTableData,
  allParams,
  user,
}) => {
  const handleTableChanged = async () => {
    if (tableChanged) {
      let { isAddRow, isEditRow, newData, isConfirmFetchApiTable } =
        tableChanged
      let tableAction = uischema?.tableAction?.action || []
      if (isAddRow) {
        let action = tableAction.find((item) => {
          return item.name === 'add'
        })
        if (action && newData) {
          await postData({
            action,
            rowData: newData,
            designContext,
            renderTableData,
            allParams,
            user,
            uischema,
          })
          uiChanged.del(uischema.key)
          uiChanged.del('isWaitUpsert')
        }
      } else if (isEditRow) {
        let action = tableAction.find((item) => {
          return item.name === 'update'
        })
        if (action && newData) {
          await putData({
            action,
            rowData: newData,
            designContext,
            renderTableData,
            allParams,
            user,
            uischema,
          })
          uiChanged.del(uischema.key)
          uiChanged.del('isWaitUpsert')
        }
      } else if (isConfirmFetchApiTable) {
        renderTableData()
        uiChanged.del('isConfirmFetchApiTable')
      }
      setIsUiChanged(uiChanged.get(''))
    }
  }

  return {
    handleTableChanged,
  }
}
